type NamedJoint = { name?: string };

/**
 * Given a string that may be either a joint UUID (map key) or a joint name,
 * returns the UUID (map key), or null if not found.
 *
 * UUID lookup is tried first (O(1)); name scan is the fallback (O(n)).
 */
export function resolveJointUuidFromRef(
  ref: string | null | undefined,
  joints: Record<string, NamedJoint | undefined>
): string | null {
  if (!ref) return null;
  if (joints[ref]) return ref;
  const entry = Object.entries(joints).find(([, j]) => j?.name === ref);
  return entry ? entry[0] : null;
}
